import EnvironmentEnum from "../EnvironmentEnum";

const CognitoConfiguration = Object.freeze({
  [EnvironmentEnum.LOCALHOST]: {
    DOMAIN: "http://localhost:20001/mse-ui/welcome",
    CLIENT_ID: "7ikilrouvcvcp0g3ji838usj9r",
  },
  [EnvironmentEnum.DEV]: {
    DOMAIN: "https://dev-nonprod-idp-internal-plutasgroup.auth.ap-southeast-2.amazoncognito.com",
    CLIENT_ID: "22pvjpjdq684b0t6n9pscj799n",
  },
  [EnvironmentEnum.DEV2]: {
    DOMAIN: "https://dev2-nonprod-idp-internal-plutasgroup.auth.ap-southeast-2.amazoncognito.com",
    CLIENT_ID: "6akn0aoke3u7svo31s7gtclrlr",
  },
  [EnvironmentEnum.SIT]: {
    DOMAIN: "https://sit-nonprod-idp-internal-plutasgroup.auth.ap-southeast-2.amazoncognito.com",
    CLIENT_ID: "6lnuq7tclunnj0hbpil29u4one",
  },
  [EnvironmentEnum.PREPROD]: {
    DOMAIN: "https://preprod-nonprod-idp-internal-plutasgroup.auth.ap-southeast-2.amazoncognito.com",
    CLIENT_ID: "6vk1anm8d196v6uglkv9pfgbop",
  },
  [EnvironmentEnum.DEMO]: {
    DOMAIN: "https://demo-nonprod-idp-internal-plutasgroup.auth.ap-southeast-2.amazoncognito.com",
    CLIENT_ID: "392upci84chsfbm6b8k41m4rq6",
  },
  [EnvironmentEnum.DEMO2]: {
    DOMAIN: "https://demo2-nonprod-idp-internal-plutasgroup.auth.ap-southeast-2.amazoncognito.com",
    CLIENT_ID: "5efb2if8t05uqf9bod499nk8qf",
  },
  [EnvironmentEnum.UAT]: {
    DOMAIN: "https://uat-nonprod-idp-internal-plutasgroup.auth.ap-southeast-2.amazoncognito.com",
    CLIENT_ID: "6bsuha91ejfjjdqcv8rq0t9jdc",
  },
  [EnvironmentEnum.PROD]: {
    DOMAIN: "https://prod-idp-internal-plutasgroup.auth.ap-southeast-2.amazoncognito.com",
    CLIENT_ID: "2um742ecnuq5a8iejvtf84eic9",
  },
});

export default CognitoConfiguration;